import DOMPurify from "dompurify";

const decodeHtmlEntities = (value) => {
  if (!value) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};

const sanitizeHtml = (value) => DOMPurify.sanitize(decodeHtmlEntities(value));

export default sanitizeHtml;
